<div class="wrapper">
  @let html = html$ | async;
  @if (requestStatus.failed) {
    <div role="alert">
      {{ 'TABLE.load_failed' | translate }}
      <button (click)="reload.next()" type="button" mat-button color="primary">{{ 'TABLE.retry' | translate }}</button>
    </div>
  }
  @if (html !== null) {
    <div @show>
      <div class="content" #content [innerHTML]="html | markdown"></div>
      <app-button-group>
        <button mat-dialog-close color="warn" mat-stroked-button>
          <mat-icon style="margin-right: 5px;">close</mat-icon>
          <mat-label>{{ 'QUERY_BUILDER.close' | translate }}</mat-label>
        </button>
        <button (click)="copyToClipboard(content.innerText)" color="primary" mat-stroked-button>
          <mat-icon style="margin-right: 5px;">file_copy</mat-icon>
          <mat-label>{{ 'COMMON.copy' | translate }}</mat-label>
        </button>
      </app-button-group>
    </div>
  }
  @if (requestStatus.loading && html === null) {
    <app-loader @hide [isLocal]="true"></app-loader>
  }
</div>
